// Auth providers.
export const AUTH_ENABLE_GOOGLE_SOCIAL_SIGN_IN = true;
export const AUTH_ENABLE_MICROSOFT_SOCIAL_SIGN_IN = true;
export const AUTH_MICROSOFT_CLIENT_ID = process.env.REACT_APP_AZURE_ID ?? '';

// Auth footer / external links.
export const AUTH_ENABLE_CONTACT_US_LINK = true;
export const AUTH_ENABLE_COOKIE_PREFERENCES_LINK = true;
export const AUTH_CONTACT_US_URL = 'https://scalar.io/contact/';

// Auth UX copy, timings, and thresholds.
export const AUTH_LOADING_LABELS = {
  accountRequirements: 'Loading the latest account requirements.',
  discovery: 'Preparing your sign-in.',
  nextStep: 'Preparing your next step.',
  productSelection: 'Loading your available products.',
  session: 'Checking your session.',
  signInDefault: 'Preparing your sign-in experience.',
  twoFactor: 'Preparing two-factor authentication.',
  workspaceSelection: 'Checking your access and available workspaces.',
} as const;

export const AUTH_INITIAL_FOCUS_DELAY_MS = 100;
export const AUTH_FIRM_SELECTOR_SEARCH_THRESHOLD = 9;
export const AUTH_COMPANY_SELECTOR_SEARCH_THRESHOLD = 1;
